import { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate, useParams } from "react-router-dom";
import BaseButton from "../BaseButton";
import BaseImage from "../BaseImage";
import IconCheck from "../../assets/images/icons/icon-check-green-circle.svg"
import IconWarning from "../../assets/images/icons/icon-warning-yellow.svg"
import { useMutation } from "@apollo/client";
import { ReportReview, ReportUnReview } from "../../apollo-client/api-query";
import usePermissions from "../../hooks/use-permissions";
import { ViewPermissions } from "../../constants";

const ReportReviewBottomNav = ({ reportDetail }) => {
  const navigate = useNavigate()
  const { id: patient_id } = useParams()
  const { myPermissions } = usePermissions()
  const canReview = myPermissions.includes(ViewPermissions.UPDATE_REVIEW)
  const [reviewReport, { loading: loadingReviewReport } ] = useMutation(ReportReview, {fetchPolicy: 'network-only'})
  const [unReviewReport, { loading: loadingUnReviewReport }] = useMutation(ReportUnReview, {fetchPolicy: 'network-only'})

  const [isNeedsReview, setIsNeedsReview] = useState()

  useMemo(() => setIsNeedsReview(reportDetail?.needsReview), [reportDetail])

  const handleClick = async () => {
    const variables = {
      variables: {
        reportId: reportDetail?.id
      }
    }
    if (isNeedsReview) await reviewReport(variables)
    else await unReviewReport(variables)
    setIsNeedsReview(!isNeedsReview)
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '84px',
        padding: '20px 40px',
        bgcolor: 'white',
        boxShadow: '0px 2px 20px 0px #5B87EF66',
        position: 'fixed',
        bottom: 0,
        zIndex: 20,
        display: canReview ? 'flex' : 'none',
        justifyContent: 'flex-end'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mr: '40px',
            padding: '10px 16px',
            cursor: 'pointer'
          }}
          onClick={() => navigate(`/patient/${patient_id}`)}
        >
          <ChevronLeftIcon />
          <Typography variant="body" color='primary.black'>
            Go back
          </Typography>
        </Box>
        <Box>
          <BaseButton
            buttonType={isNeedsReview ? 'primary' : 'default'}
            onClick={handleClick}
            loading={loadingReviewReport || loadingUnReviewReport}
          >
            <BaseImage 
              src={isNeedsReview ? IconCheck : IconWarning}
              sx={{
                width: '24px',
                height: '24px',
                mr: '8px'
              }}
            />
            <Typography variant="body" color={isNeedsReview ? 'white' : 'primary.black' }>
              {isNeedsReview ? 'Pass report for review' : 'Revoke passed status'}
            </Typography>
          </BaseButton>
        </Box>
      </Box>
    </Box>
  )
}

export default ReportReviewBottomNav